var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "CircleIndicator",
    style: {
      width: ((_vm.size) + "px"),
      height: ((_vm.size) + "px")
    }
  }, [_vm.isLoading ? _c('div', {
    staticClass: "CircleIndicator-loading",
    style: {
      borderColor: _vm.bgColor,
      borderWidth: ((_vm.size * 0.04) + "px")
    }
  }) : _vm._e(), _c('div', {
    staticClass: "CircleIndicator-slot"
  }, [_vm.$slots.default ? _c('span', [_vm._t("default")], 2) : _vm.icon ? _c('span', {
    staticClass: "CircleIndicator-icon",
    class: _vm.icon,
    style: {
      fontSize: ((_vm.size * 0.3) + "px"),
      color: _vm.primaryColor
    }
  }) : _vm._e()]), _c('div', {
    ref: function (el) {
      _vm.reference = el;
    },
    staticClass: "CircleIndicator-animation",
    class: {
      'CircleIndicator-animation-startFromTop': _vm.startFromTop
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }